<template>
  <div class="protocol login-protocol">
    <navigation>《委托划扣授权书》</navigation>
    <section class="content">
      <p class="text tab-2"><b>重要提示：</b></p>
      <p class="text tab-2"><b>为了保障您的合法权益，您应当仔细阅读本授权书，请您务必审慎阅读、充分理解本授权书的全部内容，特别是免除或减轻重庆新铂风科技有限公司责任，或限制您权利的条款。其中免除或限制责任条款可能以加粗形式提示您注意。</b></p>
      <p class="text tab-2"><b>如您不同意本授权书的内容，或对本授权书任何条款持有异议，请不要进行签署或点击确认及后续操作。本授权书一经签署或点击确认即视为您已完全理解并同意本授权书的全部条款，并视为已完成相关授权。</b></p>
      <p class="text tab-2"><b>授权人:</b></p>
      <p class="text tab-2">身份证号：</p>
      <p class="text tab-2">联系方式：</p>
      <p class="text tab-2"><b>被授权人：重庆新铂风科技有限公司</b></p>
      <p class="text tab-2">统一社会信用代码：91500105MADJGGW61C</p>
      <p class="text tab-2"> <b>一、授权内容</b></p>
      <p class="text tab-2">为保障各方合法权益，<b>授权人不可撤销地授权并同意：</b></p>
      <p class="text tab-2"><b>被授权人及被授权人指定的第三方支付公司及/或银行有权从授权人绑定在天美贷平台的银行账户内扣收授权人依据相关协议及/或服务所产生的应付款项，届时无需事先通知被授权人或另行获得授权人的单独同意。</b></p>
      <p class="text tab-2"><b>授权人授权并同意被授权人指定任何有资质的第三方支付公司及/或银行从授权人的银行账户中进行款项扣划，包括不限于：宝付网络科技（上海）有限公司、网银在线(北京)科技有限公司等。</b></p>
      <p class="text tab-2"> <b> 二、授权人承诺</b></p>
      <p class="text tab-2"><b>1、授权人特就委托划扣授权的相关事宜承诺如下：</b></p>
      <p class="text tab-2">（1）授权人将自行承担因银行账户余额不足或被查封、冻结以及其他不可归责于被授权人的事由导致无法按时足额扣款或扣款错误而导致的任何法律责任。</p>
      <p class="text tab-2">（2）若授权人变更及/或新增上述绑定扣款账户，授权人应在变更及/或新增账户后及时告知被授权人相关账户信息，<b>本授权书对授权人变更及/或新增的账户继续有效</b>。</p>
      <p class="text tab-2">（3） <b>授权人明确知悉被授权人指定的第三方支付公司及/或银行依据本授权书进行的委托扣款操作引起的一切法律纠纷或风险，由授权人独立承担或解决。</b></p>
      <p class="text tab-2">（4）授权人明确知悉本授权书是用户开通委托划扣的必备法律文件之一，授权人保证本授权书所涉及的各项资料均准确无误、真实合法，未提供任何虚假信息。</p>
      <p class="text tab-2"><b>三、授权期限</b></p>
      <p class="text tab-2"><b>本授权书自授权人确认/签署之日起生效，直至授权人清偿所有款项或被授权人书面通知本授权书失效之日方告失效。</b></p>
      <p class="text tab-2"><b>四、授权人特别声明</b></p>
      <p class="text tab-2"><b>1、</b>本授权人系授权人向被授权人作出的单方承诺，效力具有独立性、不可撤销性，不得随意变更、解除或终止，且不受其他协议/合同效力的影响。</p>
      <p class="text tab-2"><b>2、授权人完全知悉并充分理解本授权书内容，本授权书内容系授权人的真实意思表示，确系授权人自愿出具。</b></p>
      <p class="text tab-2"><b>五、授权书签署形式</b></p>
      <p class="text tab-2"><b> 授权人可通过面签授权（包括但不限于面签专门的授权文件、含有授权条款的合同或文件等）或信息网络方式（在包括但不限于通过被授权人合作方运营的相关客户端、电话以及其他及时通信工具等数据电文方式进行签署或确认授权）给予被授权人授权。</b></p>
      <p class="text tab-2"> </p>
      <p class="text tab-2">授权人（电子签名）：</p>
      <p class="text tab-2"> 日期： 年 月 日</p>
    </section>
    <p data-sensors-exposure-property-page_status="page_bottom" data-sensors-exposure-event-name="general_event">&nbsp;<!-- 监听协议滑动到了底部，每个协议都加上--></p>
  </div>
</template>

<script>
export default {
  name: 'deductionProtocol',
  created () {
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.login-protocol {
  background-color: white;

  .fz24 {
    font-size: 24px !important;
  }

  .content {
    padding: 0 48px;

    .title {
      font-weight: bolder;
      color: #333333;
      font-size: 28px;
      text-indent: 40px;
      line-height: 44px;
      margin-top: 10px;
    }

    .text {
      color: #333333;
      font-size: 28px;
      text-indent: 40px;
      line-height: 44px;
    }

    .text:last-child {
      margin-bottom: 10px;
    }

    .underline {
      text-indent: 40px;
      font-weight: bold;
      text-decoration: underline;
    }

    .underline:last-child {
      margin-bottom: 10px;
    }
  }
}
</style>
